import React from "react";
import { Step1 } from "./Step1";
import { StepSpouse } from "./StepSpouse";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Step4 } from "./Step4";
import { Step5 } from "./Step5";
import { Step6 } from "./Step6";
import { StepPaymentCompleted } from './StepPaymentCompleted'
import { StepFinish } from './StepFinish'
import { StepUsedCarFile } from './StepUsedCarFile'
import { StepUsedCarFileFinish } from './StepUsedCarFileFinish'
import { StepNoAccept } from './StepNoAccept'

const Step = ({ index = 0 }: IPropsPages) => {
    const switchPage = [
        <Step1 />,
        <Step2 />, 
        <StepSpouse />,
        <Step3 />,
        <Step4 />,
        <Step5 />,
        <Step6 />,
        <StepPaymentCompleted />,
        <StepFinish />,
        <StepUsedCarFile />,
        <StepUsedCarFileFinish />,
        <StepNoAccept />
    ]
    return (
        <>
            {switchPage[index]}
        </>
    );
}

export { Step };